import { useEffect } from 'react';
import { Link, useNavigate } from '@tanstack/react-router';

import config from '@/config';

import styles from './MyLibrary.module.css';
import { useLoadData } from './MyLibrary.hooks';

export const MyLibrary = () => {
	const navigate = useNavigate();
	const { isLoaded, articles } = useLoadData();
	useEffect(() => {
		navigate({
			to: '/',
			search: {
				section: 'library',
			},
		});
	}, []);

	if (!isLoaded) {
		return <section className={styles['library']}>Loading</section>;
	}

	if (!articles.length) {
		return <Empty />;
	}

	return (
		<section className={styles['library']}>
			<Content articles={articles} />
		</section>
	);
};

function Empty() {
	const { title } = config.build;
	return (
		<section className={styles['empty']}>
			<div>
				<Bookmark />
				<h1>Favorite Articles</h1>

				<h2>
					Bookmark your favorite articles from{' '}
					<em>{title} Magazine</em>.
				</h2>
			</div>
		</section>
	);
}

function Content({ articles }: ContentProps) {
	const { title } = config.build;
	return (
		<>
			<h1>Favorite Articles</h1>
			<h2>
				Bookmark your favorite articles from <em>{title} Magazine</em>.
			</h2>
			<div className={styles['article']}>
				{articles.map(a => (
					<Article key={a.id} article={a} />
				))}
			</div>
		</>
	);
}

interface ContentProps {
	articles: Array<any>;
}

function Article({ article }: ArticleProps) {
	const { id, thumbnail, name } = article;
	/*const dateTime = DateTime.fromJSDate(new Date(created)).toFormat(
		DATE_FORMAT,
	);*/
	console.log(`ARTICLE`, article);
	const from = `${window.location.pathname}?section=magazines`;
	return (
		<Link
			to={`/favorite/$id`}
			params={{
				id,
			}}
			from={from}
			id={`favorite-article-${id}`}
			className={styles['article-item-container']}
		>
			<div className={styles['article-item']}>
				<div className={styles['image']}>
					{thumbnail ? (
						<img src={thumbnail} alt={'Thumbnail'} />
					) : (
						<div />
					)}
				</div>
				<div className={styles['title']}>
					<h3>{name['en']}</h3>
				</div>
				<div className={styles['content']}></div>
			</div>
		</Link>
	);
}

interface ArticleProps {
	article: any;
}

function Bookmark() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="75"
			viewBox="0 0 24 24"
			width="75"
		>
			<path d="M0 0h24v24H0V0z" fill="none" />
			<path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z" />
		</svg>
	);
}
